/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import './AuthLayout.css'
import { useLayout } from '../../../../_metronic/layout/core'
import clsx from 'clsx'

const AuthLayout = () => {
  const {config} = useLayout()
  const intl = useIntl()

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <>
      <div className='d-flex flex-row h-100'>
        {/* Mobile version */}
        <div className='d-flex flex-column flex-row-fluid d-xl-none'>
          <div className='d-flex flex-row-fluid flex-center'>
            <div className='d-flex flex-column flex-row-fluid'>
              <div className='d-flex flex-column-fluid flex-center mt-15'>
                <Link to='/'>
                  {config.layoutType === 'dark-sidebar' ? (
                    <img
                      alt='Logo'
                      src={toAbsoluteUrl('/media/logos/adminSiteWhite.svg')}
                      className='auth-layout-logo'
                    />
                  ) : (
                    <img
                      alt='Logo'
                      src={toAbsoluteUrl('/media/logos/adminSite.svg')}
                      className='auth-layout-logo'
                    />
                  )}
                </Link>
              </div>

              <div className='d-flex flex-column-fluid flex-center'>
                <div className='w-700px mt-10 mb-15 mx-15'>
                  <h1
                    className={clsx(
                      'auth-layout-title fw-bolder text-center mb-5',
                      config.layoutType
                    )}
                  >
                    {intl.formatMessage({id: 'AUTH.LAYOUT.TITLE'})}
                  </h1>{' '}
                  <div
                    className={clsx(
                      'auth-layout-description fs-base text-center',
                      config.layoutType
                    )}
                  >
                    {intl.formatMessage({id: 'AUTH.LAYOUT.DESCRIPTION'})}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={clsx('aside-body d-flex flex-row-fluid', config.layoutType)}>
            <div className='d-flex flex-column flex-row-fluid'>
              <div className='d-flex flex-column-fluid flex-center'>
                <div className='m-15 w-400px'>
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Desktop version */}
        <div className='d-flex flex-column flex-row-fluid d-none d-xl-flex'>
          <div className='d-flex flex-row flex-column-fluid'>
            <div className='d-flex flex-row-fluid flex-center'>
              <div className='d-flex flex-column flex-row-fluid'>
                <div className='d-flex flex-column-fluid flex-center'>
                  <Link to='/'>
                    {config.layoutType === 'dark-sidebar' ? (
                      <img
                        alt='Logo'
                        src={toAbsoluteUrl('/media/logos/adminSiteWhite.svg')}
                        className='auth-layout-logo'
                      />
                    ) : (
                      <img
                        alt='Logo'
                        src={toAbsoluteUrl('/media/logos/adminSite.svg')}
                        className='auth-layout-logo'
                      />
                    )}
                  </Link>
                </div>

                <div className='d-flex flex-column-fluid flex-center'>
                  <div className='w-700px pt-10'>
                    <h1
                      className={clsx(
                        'auth-layout-title fw-bolder text-center mb-5',
                        config.layoutType
                      )}
                    >
                      {intl.formatMessage({id: 'AUTH.LAYOUT.TITLE'})}
                    </h1>{' '}
                    <div
                      className={clsx(
                        'auth-layout-description fs-base text-center',
                        config.layoutType
                      )}
                    >
                      {intl.formatMessage({id: 'AUTH.LAYOUT.DESCRIPTION'})}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={clsx('aside-body d-flex flex-row-fluid flex-center', config.layoutType)}
            >
              <div className='d-flex flex-column flex-row-fluid'>
                <div className='d-flex flex-column-fluid flex-center'>
                  <div className='w-400px'>
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export {AuthLayout}
